import CommonNumberField from "./CommonNumberField";

export default CommonNumberField;
